$ ->
  $(".dropdown-button").click ->
    $button = $(@)
    $menu = $button.siblings(".dropdown-menu")
    $menu.toggleClass "show-menu"
    $menu.children("li").click ->
      $menu.removeClass "show-menu"
      $button.html $(@).html()
